// React drop down props
export const locationDropDownProps = {
	options: [
		{
			label: 'All locations',
			key: 'location',
			value: 'all'
		},
		{
			label: 'Your locations',
			key: 'location',
			value: 'your'
		}
	],
	title: "Location"
};

export const sortDropDownProps = {
	options: [
		{
			label: 'Nearest',
			key: 'sort',
			value: 'nearest'
		},
		{
			label: 'Farthest',
			key: 'sort',
			value: 'farthest'
		}
	],
	title: "Sort"
};

// React drop down multi props
export const serviceDropDownProps = {
	options: [
		{
			label: 'Service 1',
			checked: false,
			key: 'service',
			value: 'service1'
		},
		{
			label: 'Service 2',
			checked: false,
			key: 'service',
			value: 'service2'
		}
	],
	title: "Service"
};

export const timeDropDownProps = {
	options: [
		{
			label: 'Morning',
			key: 'time',
			checked: false,
			value: 'morning'
		},
		{
			label: 'Afternoon',
			checked: false,
			key: 'time',
			value: 'afternoon'
		},
		{
			label: 'Evening',
			checked: false,
			key: 'time',
			value: 'evening'
		}
	],
	title: "Time of day"
};

export const modeProps = {
	options: [
		{
			label: 'Face to face',
			key: 'mode',
			checked: false,
			value: 'face'
		},
		{
			label: 'Drop in video/telephone call',
			key: 'mode',
			checked: false,
			value: 'drop in'
		},
		{
			label: 'Online video call',
			key: 'mode',
			checked: false,
			value: 'online video'
		},
		{
			label: 'Telephone call',
			key: 'mode',
			checked: false,
			value: 'telephone'
		},
		{
			label: 'Online chat counselling',
			key: 'mode',
			checked: false,
			value: 'online chat'
		},
	],
	title: "Mode"
};
